import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { postQuestionnairePrice } from '../api/processor'
import { updateCurrentStatus, updateStatuses } from '../processor/slices/globalSlice'
import { updatePresetPrice, updatePrice } from '../processor/slices/priceSlice'

const useProcessorPrice = () => {
  const dispatch = useDispatch()
  const [price, setPrice] = useState('')
  const [selected, setSelected] = useState(null)
  const [submitting, setSubmitting] = useState(false)
  const hashedId = useSelector((state) => state.global.hashedId)
  const total = useSelector((state) => state.price.total)
  const presetPrice = useSelector((state) => state.price.presetPrice)
  const possiblePrices = useSelector((state) => state.price.possiblePrices)

  const init = useCallback(() => {
    const curPrice = possiblePrices.find((item) => item?.id === presetPrice?.id && item?.is_org === presetPrice?.is_org)
    if (curPrice) setSelected(curPrice)
    setPrice(total)
  }, [possiblePrices, total, presetPrice])

  const revert = useCallback(() => {
    init()
  }, [init])

  useEffect(() => {
    init()
  }, [init])

  const onSelect = (item) => {
    const isSelectingSelectedItem = item.id === selected?.id && item.is_org === selected?.is_org
    if (isSelectingSelectedItem) {
      setSelected(null)
      setPrice(null)
    } else {
      setSelected(item)

      if (item.dynamic_price && item.id === presetPrice?.id && item.is_org === presetPrice?.is_org) {
        setPrice(total)
      } else {
        setPrice(item.price)
      }
    }
  }

  const onChange = (price) => setPrice(price === '' ? null : Number(price))

  const onSubmit = async () => {
    const curPresetPrice = possiblePrices.find((e) => e.id === selected?.id && e.is_org === selected?.is_org)
    if (!curPresetPrice) return
    const data = {
      questionnaire_request: {
        price: price,
        preset_price_type: curPresetPrice?.is_org ? 'org' : 'building',
        preset_price_id: curPresetPrice?.id,
      },
    }
    try {
      const res = await postQuestionnairePrice(hashedId, data)
      dispatch(updatePresetPrice(curPresetPrice))
      dispatch(updatePrice(res?.data?.request?.price))
      dispatch(updateStatuses(res.data.request?.statuses))
      dispatch(updateCurrentStatus(res.data.request?.current_status))
    } catch (error) {
    } finally {
      setSubmitting(false)
    }
  }

  return {
    currentPrice: total,
    presetPrice,
    price,
    selected,
    onSelect,
    onChange,
    onSubmit,
    possiblePrices,
    revert,
    submitting,
    setSubmitting,
  }
}

export default useProcessorPrice
